<template>
  <div>
    <el-input ref="input" v-model="value" :data-code="params.field || ''" v-bind="params.inputProps" @blur="onBlur" />
  </div>
</template>

<script>
import Vue from 'vue'
import TableKeyboardNav from '@/mixin/TableKeyboardNav'
export default Vue.extend({
  name: 'AccountingDocumentSummaryEditor',
  mixins: [TableKeyboardNav],
  data() {
    return {
      value: '',
      type: 'input'
    }
  },
  created() {
    console.log('oninputeditor')
    this.value = this.params.value
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.input) {
        this.$refs.input.focus()
        // this.$refs.input.select()
      }
    })
  },
  methods: {
    getValue() {
      if (this.params.isUppercase) {
        return this.value && this.value.toUpperCase()
      }
      return this.value
    },
    onBlur() {
      console.log('input-stop',)
      this.params.api.stopEditing()
    }
  }
})
</script>
